<script>
const sidebarMenu = [
  // { path: '/', icon: 'fa fa-th', title: 'Home' },

  //Highlight
  {
    path: "/dashboard/highlight",
    icon: "far fa-th-large",
    title: "Highlights",
    children: [
      { path: "/dashboard/highlight/label-maker", title: "Label Maker" },
      { path: "/dashboard/highlight/oil-maker", title: "Oil Maker" },
      { path: "/dashboard/highlight/customer", title: "Customer" },
    ],
  },

  //Activities
  {
    path: "/dashboard/customer-activities",
    icon: "far fa-chart-bar",
    title: "Customer Activities",
  },
  
  //Data Submission
  {
    path: "/dashboard/data-submission",
    icon: "fas fa-upload",
    title: "Data Submission",
    children: [
      { path: "/dashboard/data-submission/label-maker", title: "Label Maker", disabled: true },
      { path: "/dashboard/data-submission/oil-maker", title: "Oil Maker", badge: "needsResubmission" },
      { path: "/dashboard/data-submission/recipient-contacts", title: "Recipient Contacts" },
      { path: "/dashboard/data-submission/reminder-settings", title: "Reminder Settings" },
    ],
  },
  //Consumer Insights
  // { path: '/dashboard/consumer-insights', icon: 'far fa-users', title: 'Consumer Insight' },

  //Reports
  {
    path: "/dashboard/reports",
    icon: "far fa-file-alt",
    title: "Reports",
    children: [
      { path: "/dashboard/reports/customer", title: "Report Customer" },
      { path: "/dashboard/reports/label-maker", title: "Report Label Maker" },
      { path: "/dashboard/reports/oil-maker", title: "Report Oil Maker" },
      { path: "/dashboard/reports/suspect", title: "Report Suspect" },
      { path: "/dashboard/reports/qrcode", title: "QR Code" },
      { path: "/dashboard/reports/summary-report", title: "Summary Report" },
      // {
      //   path: "/dashboard/reports/not-found-report",
      //   title: "Not Found Report",
      // },
    ],
  },

  //Summary Report
  // { path: '/dashboard/summary-report', icon: 'far fa-file', title: 'Summary Report' },

  //Domain Detection
  {
    path: "/dashboard/domain-detection",
    icon: "far fa-search",
    title: "Domain Detection",
    children: [
      { path: "/dashboard/domain-detection/summary", title: "Summary" },
      { path: "/dashboard/domain-detection/review-domain", title: "Review Domain" },
      { path: "/dashboard/domain-detection/domain-distribution", title: "Domain Distribution" },
    ],
  },

  //Settings
  {
    path: "/dashboard/settings",
    icon: "far fa-wrench",
    title: "Settings",
    children: [
      {
        path: "/dashboard/settings/log-history-activity",
        title: "Log History Activity",
      },
      {
        path: "/dashboard/settings/user-management",
        title: "User Management",
        children: [
          {
            path: "/dashboard/settings/user-management/dashboard-user",
            title: "Dashboard User",
          },
          {
            path: "/dashboard/settings/user-management/oil-maker-app",
            title: "Oil Maker App",
          },
          {
            path: "/dashboard/settings/user-management/penindakan-app",
            title: "Penindakan App",
          },
        ],
      },
    ],
  },

  //CSO
  // { path: '/cso', icon: 'fas fa-table', title: 'CSO',
  //   children: [
  //     { path: '/cso/exit-permit', title: 'Gatepass' },
  //     { path: '/cso/customer-quotation', title: 'Quotation' },
  //     { path: '/cso/insurance-policy', title: 'Insurance Policy' },
  //     { path: '/cso/master-data', title: 'Master Data',
  //       children: [
  //         { path: '/cso/master-data/color', title: 'Warna Mobil' },
  //         { path: '/cso/master-data/brand-&-type', title: 'Merk Dan Tipe Mobil' },
  //         { path: '/cso/master-data/customer', title: 'Pelanggan' },
  //         { path: '/cso/master-data/customer-car', title: 'Mobil Pelanggan' },
  //         { path: '/cso/master-data/laborer', title: 'Pekerja' },
  //         { path: '/cso/master-data/supplier', title: 'Supplier' },
  //       ]
  //     },
  //   ]
  // },
];

// function filterDashboardUser(menu) {
//   return menu
//     .map((item) => {
//       // If the item has children, process them recursively
//       if (item.children) {
//         return {
//           ...item,
//           children: filterDashboardUser(item.children), // Filter children recursively
//         };
//       }
//       return item; // Otherwise, return the item as is
//     })
//     .filter((item) => item.title !== "Dashboard User"); // Filter out "Dashboard User"
// }

// const filteredMenu = filterDashboardUser(sidebarMenu);

// console.log(filteredMenu);

export default sidebarMenu;
</script>
